// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__9ve3G","icon":"Checkbox_icon__cGeKR","label":"Checkbox_label__tDXOg"};